import Header from "../Component/Header";
import {
  Layout,
  theme,
  Button,
  Input,
  Spin,
  Col,
  Row,
  message,
  Statistic,
  Select,
  DatePicker,
  InputNumber,
  Modal,
  Table,
  Popover,
} from "antd";
import { ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";

import dayjs from "dayjs";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Message from "../Component/Message";
import { GlobalContext } from "../Component/GlobalContextProvider";
import { gql, useMutation, useLazyQuery, useQuery } from "@apollo/client";
import { getUrl } from "aws-amplify/storage";
import Classficator from "../Component/Classficator";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import axios from "axios";
import { post } from "aws-amplify/api";

function getStatusColor(status) {
  switch (status) {
    case "On Progress":
      return "cyan";
    case "Finished":
      return "red";
    case "Pending":
      return "orange";
    case "Paid":
      return "blue";
    case "Creating":
      return "purple";
    default:
      return "grey";
  }
}

const GET_TECHNICIAN = gql`
  query MyQuery($request_id: uuid!) {
    get_technician_by_request(args: { input_request_id: $request_id }) {
      name
      id
      email
    }
  }
`;
const GET_TECHNICIAN_LIST = gql`
  query Query {
    technician {
      id
      name
      email
    }
  }
`;

const GET_REQUEST_FILE = gql`
  query MyQuery($request_id: uuid!) {
    request_file(where: { request_id: { _eq: $request_id } }) {
      name
      storage_path
      upload_time
      type
      description
    }
  }
`;
const UPDATE_REQUEST = gql`
  mutation UpdateRequest(
    $id: uuid!
    $status: String!
    $due_date: timestamptz
    $actual_price: money
    $estimate_price: money
    $download_link: String
    $update_date: timestamptz
  ) {
    update_request_by_pk(
      pk_columns: { id: $id }
      _set: {
        status: $status
        due_date: $due_date
        actual_price: $actual_price
        estimate_price: $estimate_price
        download_link: $download_link
        update_date: $update_date
      }
    ) {
      id
    }
  }
`;
const INSERT_REQUEST_TECHNICIAN = gql`
  mutation InsertRequestTechnician($request_id: uuid!, $technician_id: uuid!) {
    insert_request_technician(
      objects: { request_id: $request_id, technician_id: $technician_id }
    ) {
      affected_rows
    }
  }
`;
const INSERT_REQUEST_JIRA = gql`
  mutation InsertRequestJira($request_id: uuid!, $jira_url: String!) {
    update_request_by_pk(
      pk_columns: { id: $request_id }
      _set: { jira_url: $jira_url }
    ) {
      id
    }
  }
`;
const DELETE_REQUEST_TECHNICIAN = gql`
  mutation DeleteRequestTechnician($request_id: uuid!, $technician_id: uuid!) {
    delete_request_technician(
      where: {
        request_id: { _eq: $request_id }
        technician_id: { _eq: $technician_id }
      }
    ) {
      affected_rows
    }
  }
`;

function RequestDetails() {
  const [height, setHeight] = useState(window.innerHeight);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [inputActualPrice, setInputActualPrice] = useState(null);
  const [inputEstimatePrice, setInputEstimatePrice] = useState(null);
  const [inputFileUrl, setInputFileUrl] = useState(null);
  const location = useLocation();
  const requestUid = location.state?.requestUid;
  const navigate = useNavigate();
  const [isMounted, setIsMounted] = useState(false);
  const [requestDetails, setRequestDetails] = useState({});

  const [showDownload, setShowDownload] = useState(false);

  const [technicianOptions, setTechnicianOptions] = useState([]);
  const [technicianInCharge, setTechnicianInCharge] = useState([]);
  const [downloadLinkLoading, setDownloadLinkLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [jiraLoading, setJiraLoading] = useState(false);
  const [fetchFileList, { loading: fileListLoading, data: fileListData }] =
    useLazyQuery(GET_REQUEST_FILE);
  const [
    fetchTechnician,
    { data: technicianInChargeData, refetch: refetchTechnician },
  ] = useLazyQuery(GET_TECHNICIAN);
  const { data: technicianListData } = useQuery(GET_TECHNICIAN_LIST);
  const [insertRequestTechnician] = useMutation(INSERT_REQUEST_TECHNICIAN);
  const [deleteRequestTechnician] = useMutation(DELETE_REQUEST_TECHNICIAN);
  const [insertRequestJira] = useMutation(INSERT_REQUEST_JIRA);

  const {
    RequestDetailData: data,
    fetchRequestDetail: fetchData,
    RequestDetailLoading: loading,
    AllRequestListData,
    handleRefetchAllRequestList,
    handleRefetchRequestList,
    handleRefetchRequestDetail,
    setIsDetailRefetching,
    RequestDetailLoading,
    deleteMessageTempUpload,
    isManager,
    setMenuNavigationPage,
  } = useContext(GlobalContext);

  const [updateRequest] = useMutation(UPDATE_REQUEST);

  useEffect(() => {
    setMenuNavigationPage("Detail");
  }, [setMenuNavigationPage]);

  useEffect(() => {
    if (technicianListData) {
      const options = technicianListData.technician.map((technician) => {
        return {
          value: technician.id,
          label: technician.name,
        };
      });
      setTechnicianOptions(options);
    }
  }, [technicianListData]);

  useEffect(() => {
    if (technicianInChargeData) {
      const technicianInCharge =
        technicianInChargeData.get_technician_by_request.map((technician) => {
          return {
            value: technician.id,
            label: technician.name,
          };
        });
      setTechnicianInCharge(technicianInCharge);
    }
  }, [technicianInChargeData]);

  //This useEffect is used to convert the fetched data to the displayed data

  useEffect(() => {
    if (data) {
      var detail = {};
      if (data.request_by_pk) {
        const dueDate = data.request_by_pk.due_date
          ? new Date(data.request_by_pk.due_date).toLocaleDateString("en-NZ", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : null;

        detail = {
          id: data.request_by_pk.id,
          dueDate: dueDate ? dayjs(dueDate, "DD/MM/YYYY") : null,
          status: data.request_by_pk.status,
          actualPrice: parseFloat(
            data.request_by_pk.actual_price.replace(/[$,]/g, "")
          ),

          estimatePrice: data.request_by_pk.estimate_price
            ? parseFloat(data.request_by_pk.estimate_price.replace(/[$,]/g, ""))
            : 0,
          updateDate: data.request_by_pk.update_date,
          requestName: data.request_by_pk.title,
          requestDescription: data.request_by_pk.description,
          workStreams: data.request_by_pk.work_streams,
          constructionMethodology: data.request_by_pk.construction_methodology,
          methodologyBuilding: data.request_by_pk.methodology_building,
          methodologyPhase: data.request_by_pk.methodology_phase,
          methodologyOutputs: data.request_by_pk.methodology_outputs,
          modelDevelopment: data.request_by_pk.model_development,
          modelPhase: data.request_by_pk.model_phase,
          modelEquipment: data.request_by_pk.model_equipment,
          modelType: data.request_by_pk.model_type,
          modelUsage: data.request_by_pk.model_usage,
          downloadLink: data.request_by_pk.download_link,
          jiraUrl: data.request_by_pk.jira_url,
          outputFormat: data.request_by_pk.output_format,
          requiredSoftware: data.request_by_pk.required_software,
          budget: data.request_by_pk.budget,
          fileDescription: [],
        };
        setSelectedStatus(detail.status);
        setSelectedDate(detail.dueDate);
        setInputActualPrice(detail.actualPrice);
        setInputEstimatePrice(detail.estimatePrice);
        setInputFileUrl(detail.downloadLink);
      } else {
        setSelectedStatus(data.status);
        detail = {
          id: data.id,
          dueDate: data.dueDate ? dayjs(data.dueDate, "DD/MM/YYYY") : null,
          status: data.status,
          actualPrice: data.actual_price,
          estimatePrice: data.estimate_price,
          updateDate: data.update_date,
          requestName: data.title,
          requestDescription: data.description,
          workStreams: data.work_streams,
          constructionMethodology: data.construction_methodology,
          methodologyBuilding: data.methodology_building,
          methodologyPhase: data.methodology_phase,
          methodologyOutputs: data.methodology_outputs,
          modelDevelopment: data.model_development,
          modelPhase: data.model_phase,
          modelEquipment: data.model_equipment,
          modelType: data.model_type,
          modelUsage: data.model_usage,
          downloadLink: data.download_link,
          jiraUrl: data.jira_url,
          outputFormat: data.output_format,
          requiredSoftware: data.required_software,
          budget: data.budget,

          fileDescription: [],
        };
        setSelectedStatus(detail.status);
        setSelectedDate(detail.dueDate);
        setInputActualPrice(detail.actualPrice);
        setInputEstimatePrice(detail.estimatePrice);
        setInputFileUrl(detail.downloadLink);
      }

      setRequestDetails(detail);
    }
  }, [data]);

  //This useEffect is used to prevent user directly access the page without login

  useEffect(() => {
    if (isMounted) {
      if (requestUid === undefined) {
        navigate("/request_list");
      } else {
        fetchData({
          variables: { requestUid: requestUid },
        });

        fetchFileList({
          variables: { request_id: requestUid },
        });
        fetchTechnician({
          variables: { request_id: requestUid },
        });
      }
    }
  }, [
    isMounted,
    navigate,
    requestUid,
    fetchData,
    fetchFileList,
    fetchTechnician,
  ]);

  useEffect(() => {
    setIsMounted(true);
    const handleResize = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const {
    token: { colorBgContainer, colorBorder },
  } = theme.useToken();

  const handleDownloadFile = async (filePath) => {
    setDownloadLinkLoading(true);

    const url = await getUrl({
      path: filePath,
      options: {
        validateObjectExistence: true,
      },
    });
    window.open(url.url.href, "_blank");

    setDownloadLinkLoading(false);
  };

  function addProjectToClockify(projectName, clientId) {
    axios
      .post(
        `https://api.clockify.me/api/v1/workspaces/${process.env.REACT_APP_CLOCKIFY_WORKSPACE_ID}/projects`,
        {
          clientId: clientId,
          name: projectName,
        },
        {
          headers: {
            "X-Api-Key": process.env.REACT_APP_CLOCKIFY_API_KEY,
          },
        }
      )
      .then(() => {
        message.success(projectName + " added to Clockify successfully");
      })
      .catch((error) => {
        message.error("Failed to add project to Clockify: " + error);
      });
  }
  const handleAddToClockify = () => {
    axios
      .get(
        `https://api.clockify.me/api/v1/workspaces/${process.env.REACT_APP_CLOCKIFY_WORKSPACE_ID}/clients`,
        {
          headers: {
            "X-Api-Key": process.env.REACT_APP_CLOCKIFY_API_KEY,
          },
        }
      )
      .then((response) => {
        const clients = response.data;
        const matchedClient = clients.find((client) => {
          const request =
            AllRequestListData.get_all_requests_with_technician_names.find(
              (item) => item.id === requestDetails.id
            );
          return (
            request &&
            client.name.toLowerCase() === request.client_name.toLowerCase()
          );
        });
        if (matchedClient) {
          console.log(matchedClient.id);
          addProjectToClockify(requestDetails.requestName, matchedClient.id);
        } else {
          axios
            .post(
              `https://api.clockify.me/api/v1/workspaces/${process.env.REACT_APP_CLOCKIFY_WORKSPACE_ID}/clients`,
              {
                name: AllRequestListData.get_all_requests_with_technician_names.find(
                  (item) => item.id === requestDetails.id
                ).client_name,
              },
              {
                headers: {
                  "X-Api-Key": process.env.REACT_APP_CLOCKIFY_API_KEY,
                },
              }
            )
            .then((response) => {
              addProjectToClockify(
                requestDetails.requestName,
                response.data.id
              );
            })
            .catch((error) => {
              console.error(`Failed to add client: ${error}`);
            });
        }
      })
      .catch((error) => {
        console.error(`Failed to retrieve clients: ${error}`);
      });
    console.log(requestDetails.requestName);
  };
  const generateProjectKey = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .join("")
      .substring(0, 5);
  };

  const handleAddToJira = async () => {
    setJiraLoading(true);
    const request = {
      email: "sam@rfsons.engineering",
      apiKey: process.env.REACT_APP_JIRA_API_KEY,
      body: {
        key: generateProjectKey(requestDetails.requestName), // project key
        name: requestDetails.requestName, // project name
        projectTypeKey: "business",
        leadAccountId: "712020:6a9cd27d-a269-4798-a21b-1cdc05a23c3c",
      },
    };
    try {
      const restOperation = post({
        apiName: "Jira",
        path: "/postRequest",
        options: {
          body: request,
        },
      });
      const response = await restOperation.response;
      const rawData = response.body.json();
      rawData.then((data) => {
        const jsonString = data.body;
        const jsonObject = JSON.parse(jsonString);
        insertRequestJira({
          variables: {
            request_id: requestDetails.id,
            jira_url:
              "https://rfsons-engineering.atlassian.net/jira/core/projects/" +
              jsonObject.key +
              "/board",
          },
        }).then(() => {
          message.success(
            requestDetails.requestName + " added to Jira successfully"
          );

          handleRefetchRequestDetail();
          handleRefetchAllRequestList();
          handleRefetchRequestList();
          setJiraLoading(false);
        });
      });
    } catch (e) {
      console.log(e);
      message.error("Failed to add project to Jira: " + e);
    }
  };

  const handleDownloadAllFiles = async (files) => {
    setShowDownload(false);
    setDownloadLinkLoading(true);
    setProgress(0);

    const zip = new JSZip();
    const folder = zip.folder("files");

    const totalFiles = files.length;
    let completedFiles = 0;

    const promises = files.map(async (file) => {
      const url = await getUrl({
        path: file.storage_path,
        options: {
          validateObjectExistence: true,
        },
      });

      const response = await fetch(url.url.href);
      const blob = await response.blob();
      folder.file(file.name, blob);
      completedFiles += 1;
      setProgress((completedFiles / totalFiles).toFixed(2));
    });

    await Promise.all(promises);

    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, "files.zip");

    setDownloadLinkLoading(false);
    setProgress(0);
  };
  const handleEditRequest = () => {
    const date = selectedDate ? dayjs(selectedDate).toISOString() : null;

    setIsDetailRefetching(true);

    updateRequest({
      variables: {
        id: requestDetails.id,
        status: selectedStatus,
        due_date: date,
        actual_price: inputActualPrice,
        estimate_price: inputEstimatePrice === 0 ? null : inputEstimatePrice,
        download_link: inputFileUrl,
        update_date: dayjs().toISOString(),
      },
    }).then(() => {
      const currentTechnicians =
        technicianInChargeData.get_technician_by_request.map((t) => t.id);
      const newTechnicians = technicianInCharge.filter(
        (t) => !currentTechnicians.includes(t.value)
      );
      const removedTechnicians = currentTechnicians.filter(
        (t) => !technicianInCharge.some((tc) => tc.value === t)
      );

      const insertPromises =
        newTechnicians.length > 0
          ? newTechnicians.map(async (technician) => {
              try {
                await insertRequestTechnician({
                  variables: {
                    request_id: requestDetails.id,
                    technician_id: technician.value,
                  },
                });
                //
              } catch (error) {
                message.error(`Failed to add technician: ${error.message}`);
                console.log(error);
              }
            })
          : [];

      const deletePromises =
        removedTechnicians.length > 0
          ? removedTechnicians.map(async (technicianId) => {
              try {
                await deleteRequestTechnician({
                  variables: {
                    request_id: requestDetails.id,
                    technician_id: technicianId,
                  },
                });
              } catch (error) {
                message.error(`Failed to remove technician: ${error.message}`);
                console.log(error);
              }
            })
          : [];
      Promise.all([...insertPromises, ...deletePromises]).then(() => {
        message.success("Request updated successfully");
        refetchTechnician();
        handleRefetchRequestDetail();
        handleRefetchAllRequestList();
        handleRefetchRequestList();
      });
    });
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 300,
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Upload Time",
      dataIndex: "upload_time",
      key: "upload_time",
      width: 100,
      sorter: (a, b) => new Date(b.upload_time) - new Date(a.upload_time),
      defaultSortOrder: "descend",
      render: (text) => {
        const date = new Date(text).toLocaleDateString("en-NZ");
        return <p>{date}</p>;
      },
    },

    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 100,
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Download",
      dataIndex: "storage_path",
      key: "storage_path",
      width: 50,
      render: (text) => (
        <Button
          onClick={() => handleDownloadFile(text)}
          icon={<DownloadOutlined />}
        />
      ),
    },
  ];

  return (
    <Header>
      <Spin
        spinning={loading || downloadLinkLoading || jiraLoading}
        percent={progress}
        fullscreen
      />
      {!loading && (
        <Layout.Content
          style={{
            marginLeft: 2,

            minHeight: 280,
            background: colorBgContainer,
            height: height - 66,
            overflowY: "hidden",
          }}
        >
          <Spin spinning={RequestDetailLoading} fullscreen />
          <div
            style={{
              width: "100%",
              height: 100,
              paddingTop: 0,

              display: "flex",
              alignItems: "center",
              position: "relative",
            }}
          >
            <Button
              type="text"
              icon={<ArrowLeftOutlined style={{ fontSize: 30 }} />}
              style={{ position: "absolute", left: "2vw" }}
              onClick={() => {
                deleteMessageTempUpload();
                navigate(-1);
              }}
            />
            <h1 style={{ margin: " auto" }}>
              {requestDetails.requestName}
              <Popover placement="bottom" content="Download the client files">
                <Button
                  type="text"
                  style={{ marginLeft: "3vw" }}
                  icon={<DownloadOutlined style={{ fontSize: 24 }} />}
                  onClick={() => {
                    setShowDownload(true);
                  }}
                />
              </Popover>
            </h1>
            <div
              style={{
                position: "absolute",
                right: "2vw",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {!requestDetails.jiraUrl && (
                <Button
                  onClick={async () => {
                    handleAddToClockify();
                    handleAddToJira();
                  }}
                >
                  Push to Jira & Clockify
                </Button>
              )}

              <Button type="primary" onClick={() => handleEditRequest()}>
                Submit changes
              </Button>
            </div>
          </div>
          <div style={{ display: "flex", paddingTop: 20 }}>
            <div
              style={{
                width: "30%",
                paddingLeft: "2vw",
                paddingRight: "2vw",
                borderTopWidth: 1,
                borderTopColor: colorBorder,
                borderTopStyle: "solid",
                overflowY: "auto",
                maxHeight: height - 186,
              }}
            >
              <Row gutter={16} style={{ paddingTop: "2vh" }}>
                <Col span={12}>
                  <Statistic
                    title="State"
                    style={{ width: "11vw" }}
                    prefix={
                      <Select
                        optionFilterProp="label"
                        value={selectedStatus}
                        style={{ width: "10vw" }}
                        onChange={(value) => {
                          setSelectedStatus(value);
                        }}
                        options={[
                          {
                            value: "On Progress",
                          },
                          {
                            value: "Finished",
                          },
                          {
                            value: "Pending",
                          },
                          {
                            value: "Paid",
                          },
                          {
                            value: "Creating",
                          },
                        ]}
                      />
                    }
                    value=" "
                    valueStyle={{
                      color: getStatusColor(requestDetails.status),
                    }}
                  />
                </Col>
                <Col span={12}>
                  <Statistic
                    title="Due Date"
                    style={{ width: "11vw" }}
                    prefix={
                      <DatePicker
                        value={selectedDate}
                        style={{ width: "10vw" }}
                        onChange={(value) => {
                          setSelectedDate(value);
                        }}
                      />
                    }
                    value={" "}
                  />
                </Col>
                <Col span={12} style={{ paddingTop: "2vh" }}>
                  <Statistic
                    title="Actual price"
                    style={{ width: "11vw" }}
                    prefix={
                      isManager && (
                        <InputNumber
                          prefix="$"
                          value={inputActualPrice}
                          onChange={(value) => {
                            setInputActualPrice(value);
                          }}
                          style={{ width: "10vw" }}
                        />
                      )
                    }
                    value={isManager ? " " : "$" + inputActualPrice}
                  />
                </Col>
                <Col span={12} style={{ paddingTop: "2vh" }}>
                  <Statistic
                    style={{ width: "11vw" }}
                    title="Estimate price"
                    prefix={
                      isManager && (
                        <InputNumber
                          prefix="$"
                          value={inputEstimatePrice}
                          onChange={(value) => {
                            value === 0
                              ? setInputEstimatePrice(null)
                              : setInputEstimatePrice(value);
                          }}
                          style={{ width: "10vw" }}
                        />
                      )
                    }
                    value={isManager ? " " : "$" + inputEstimatePrice}
                  />
                </Col>
                <Col span={12} style={{ paddingTop: "2vh" }}>
                  <Statistic
                    style={{ width: "11vw" }}
                    title="Budget"
                    value={requestDetails.budget ? requestDetails.budget : "-"}
                  />
                </Col>
                <Col span={12} style={{ paddingTop: "2vh" }}>
                  <Statistic
                    style={{ width: "11vw" }}
                    title="Output Format"
                    value={
                      requestDetails.outputFormat
                        ? requestDetails.outputFormat
                        : "-"
                    }
                  />
                </Col>
                <Col span={12} style={{ paddingTop: "2vh" }}>
                  <Statistic
                    style={{ width: "11vw" }}
                    title="Required Software"
                    value={
                      requestDetails.requiredSoftware
                        ? requestDetails.requiredSoftware
                        : "-"
                    }
                  />
                </Col>
              </Row>
              <Statistic
                title="Technician In Charge"
                prefix={
                  <Select
                    mode="multiple"
                    style={{ width: "23.4vw" }}
                    value={technicianInCharge.map((item) => item.value)}
                    options={technicianOptions}
                    optionFilterProp="label"
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    onChange={(value) => {
                      console.log(
                        technicianOptions.filter((item) =>
                          value.includes(item.value)
                        )
                      );

                      setTechnicianInCharge(
                        technicianOptions.filter((item) =>
                          value.includes(item.value)
                        )
                      );
                    }}
                  />
                }
                value={" "}
                valueStyle={{ fontSize: 16 }}
                style={{ paddingTop: "2vh" }}
              />

              <Statistic
                title="Output Files URL (Share the Ondrive link)"
                prefix={
                  <Input
                    value={inputFileUrl}
                    onChange={(e) => {
                      setInputFileUrl(e.target.value);
                    }}
                    style={{ width: "23.4vw" }}
                  />
                }
                value={" "}
                valueStyle={{ fontSize: 16 }}
                style={{ paddingTop: "2vh" }}
              />
              <Statistic
                title={"Jira Url"}
                prefix={
                  requestDetails.jiraUrl ? (
                    <a href={requestDetails.jiraUrl}>
                      {requestDetails.jiraUrl}
                    </a>
                  ) : (
                    <div>-</div>
                  )
                }
                value={" "}
                valueStyle={{ fontSize: 16 }}
                style={{ paddingTop: "2vh" }}
              />

              {requestDetails.workStreams !== "" || "None" ? (
                <Statistic
                  title="Work Streams"
                  value={Classficator(requestDetails.workStreams)}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}
              {requestDetails.constructionMethodology &&
              requestDetails.constructionMethodology.length > 0 ? (
                <Statistic
                  title="Construction Methodology"
                  value={requestDetails.constructionMethodology
                    .map((item) => Classficator(item))
                    .join(", ")}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}

              {requestDetails.methodologyBuilding &&
              requestDetails.methodologyBuilding.length > 0 ? (
                <Statistic
                  title="Methodology Building"
                  value={requestDetails.methodologyBuilding
                    .map((item) => Classficator(item))
                    .join(", ")}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}
              {requestDetails.methodologyPhase !== "" &&
              requestDetails.methodologyPhase !== "None" ? (
                <Statistic
                  title="Methodology Phase"
                  value={Classficator(requestDetails.methodologyPhase)}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}

              {requestDetails.methodologyOutputs &&
              requestDetails.methodologyOutputs.length > 0 ? (
                <Statistic
                  title="Methodology Outputs"
                  value={requestDetails.methodologyOutputs
                    .map((item) => Classficator(item))
                    .join(", ")}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}
              {requestDetails.modelDevelopment &&
              requestDetails.modelDevelopment.length > 0 ? (
                <Statistic
                  title="Model Development"
                  value={requestDetails.modelDevelopment
                    .map((item) => Classficator(item))
                    .join(", ")}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}
              {requestDetails.modelPhase !== "" &&
              requestDetails.modelPhase !== "None" ? (
                <Statistic
                  title="Model Phase"
                  value={Classficator(requestDetails.modelPhase)}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}
              {requestDetails.modelEquipment &&
              requestDetails.modelEquipment.length > 0 ? (
                <Statistic
                  title="Model Equipment"
                  value={requestDetails.modelEquipment
                    .map((item) => Classficator(item))
                    .join(", ")}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}
              {requestDetails.modelType &&
              requestDetails.modelType.length > 0 ? (
                <Statistic
                  title="Model Type"
                  value={requestDetails.modelType
                    .map((item) => Classficator(item))
                    .join(", ")}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}
              {requestDetails.modelUsage &&
              requestDetails.modelUsage.length > 0 ? (
                <Statistic
                  title="Model Usage"
                  value={requestDetails.modelUsage
                    .map((item) => Classficator(item))
                    .join(", ")}
                  valueStyle={{ fontSize: 16 }}
                  style={{ paddingTop: "2vh" }}
                />
              ) : null}

              <Statistic
                title="Description"
                value={requestDetails.requestDescription}
                valueStyle={{ fontSize: 16 }}
                style={{ paddingTop: "2vh", paddingBottom: "5vh" }}
              />
            </div>
            <div
              style={{
                width: "70%",
                borderTopWidth: 1,
                borderTopColor: colorBorder,
                borderTopStyle: "solid",
                maxHeight: height - 186,
              }}
            >
              <Message chatroomId={requestUid} height={height - 186} />
            </div>
          </div>
          <Modal
            open={showDownload}
            onCancel={() => setShowDownload(false)}
            width="80vw"
            title="Client Files"
            footer={[
              <Button
                type="primary"
                key="download"
                onClick={() =>
                  handleDownloadAllFiles(fileListData?.request_file)
                }
              >
                Download All
              </Button>,
            ]}
          >
            <Table
              dataSource={fileListData?.request_file}
              loading={fileListLoading || downloadLinkLoading}
              columns={columns}
              style={{ maxHeight: "80vh", overflowY: "auto" }}
              pagination={false}
              rowKey="storage_path"
            />
          </Modal>
        </Layout.Content>
      )}
    </Header>
  );
}

export default RequestDetails;
